/**
/**
 * @sw-package discovery
 */

import './page/sw-sales-channel-detail';

/**
 * @deprecated tag:v6.8.0 - Will be @private
 */
Shopware.Component.register('sw-sales-channel-detail-theme', () => import('./view/sw-sales-channel-detail-theme'));
